import React from 'react'
import {message} from "antd";
import style from "../Home.module.css";
import AchievementManageInfo from "./AchievementManageInfo";
import Util from "../../../utils/utils";
import Header from "../Header";
import LeftMenu from "../LeftMenu";
import PermissionUtils from "../../../utils/permissionUtils";

class AchievementManage extends React.Component {
    componentDidMount() {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (Util.isEmpty(userName)) {
            this.props.history.push("/login")
        } else {
            let userRole = JSON.parse(window.sessionStorage.getItem("userRole"));
            if (userRole !== 0) {
                message.error("你没有权限访问!");
                this.props.history.push("/home");
            } else {
                PermissionUtils.getUserPermission(this, '100015');
            }
        }
    }

    render() {
        return (
            <div className={style['home']}>
                <Header history={this.props.history}/>
                <LeftMenu history={this.props.history}/>
                <AchievementManageInfo history={this.props.history}/>
            </div>
        )
    }
}

export default AchievementManage;